var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2Flat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FB5B5B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9062 24.25V26.5H12.4688V24.5664L18.0234 18.5078C18.6328 17.8203 19.1133 17.2266 19.4648 16.7266C19.8164 16.2266 20.0625 15.7773 20.2031 15.3789C20.3516 14.9727 20.4258 14.5781 20.4258 14.1953C20.4258 13.6562 20.3242 13.1836 20.1211 12.7773C19.9258 12.3633 19.6367 12.0391 19.2539 11.8047C18.8711 11.5625 18.4062 11.4414 17.8594 11.4414C17.2266 11.4414 16.6953 11.5781 16.2656 11.8516C15.8359 12.125 15.5117 12.5039 15.293 12.9883C15.0742 13.4648 14.9648 14.0117 14.9648 14.6289H12.1406C12.1406 13.6367 12.3672 12.7305 12.8203 11.9102C13.2734 11.082 13.9297 10.4258 14.7891 9.94141C15.6484 9.44922 16.6836 9.20312 17.8945 9.20312C19.0352 9.20312 20.0039 9.39453 20.8008 9.77734C21.5977 10.1602 22.2031 10.7031 22.6172 11.4062C23.0391 12.1094 23.25 12.9414 23.25 13.9023C23.25 14.4336 23.1641 14.9609 22.9922 15.4844C22.8203 16.0078 22.5742 16.5312 22.2539 17.0547C21.9414 17.5703 21.5703 18.0898 21.1406 18.6133C20.7109 19.1289 20.2383 19.6523 19.7227 20.1836L16.0312 24.25H23.9062Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Flat);
export default __webpack_public_path__ + "static/media/2_flat.6e0f6220d03e5bef84d396dd04bf443d.svg";
export { ForwardRef as ReactComponent };